var getInnerText = function (jsx) {
    if (!jsx || typeof jsx === 'boolean') {
        return '';
    }
    if (typeof jsx === 'number') {
        return jsx.toString();
    }
    if (typeof jsx === 'string') {
        return jsx;
    }
    if (Array.isArray(jsx)) {
        return jsx.reduce(function (previous, current) {
            return "" + previous + getInnerText(current);
        }, '');
    }
    if (Object.prototype.hasOwnProperty.call(jsx, 'props') &&
        Object.prototype.hasOwnProperty.call(jsx.props, 'children')) {
        return getInnerText(jsx.props.children);
    }
    return '';
};

export { getInnerText };
